import MainPageContent from "./components/MainPageContent";

function App() {
  return (
    <>
    <div className="App">
      <MainPageContent />
    </div>
    </>

  );
}

export default App;
